/**
 * 操作渠道档案
 */
import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, message, Select } from 'antd';
import { upsertChannel } from '@/service/channelRecode';

interface OperateModalProps {
  reloadData: () => void;
  closeModal: () => void;
  type: string;
  data?: any;
}

const OperateModal = (props: OperateModalProps) => {
  const [form] = Form.useForm();
  const { reloadData, closeModal, type, data } = props;
  const [submitNoRepetition, setSubmitNoRepetition] = useState(true); // 不能重复请求
  const [areaCode, setAreaCode] = useState<any>([]); // 车队选择

  useEffect(() => {
    carInterviewEdit()
  }, []);

  // 编辑的时候赋值
  const carInterviewEdit = async () => {
    if (type === 'edit') {
      const params = { cateName: data.name }
      form.setFieldsValue(data)
    }
  }

  //评级
  const safeGrade = [
    { label: 'A', value: 'A' },
    { label: 'B', value: 'B' },
    { label: 'C', value: 'C' },
    { label: 'D', value: 'D' },

  ]

  //车队状态
  const safeState = [
    { label: '启用', value: '启用' },
    { label: '停用', value: '停用' },
  ]

  // 提交
  const submit = async (values: any) => {
    if (submitNoRepetition) {
      setSubmitNoRepetition(false)
      const params = { ...values };
      if (type === 'edit') {
        params.id = data.id;
      }
      const res = await upsertChannel(params);
      if (res.status == 200) {
        setSubmitNoRepetition(true)
      }
      if (res.data?.code === 0) {
        message.success(type === 'add' ? '添加成功' : '修改成功');
        closeModal();
        reloadData();
      }
    }
  }

  return (
    <Modal
      title={type === 'add' ? '添加渠道档案' : '编辑渠道档案'}
      visible
      onCancel={closeModal}
      onOk={() => form.submit()}
      bodyStyle={{ maxHeight: '70vh', overflow: 'auto' }}
      centered
      maskClosable={false}
    >
      <Form
        form={form}
        autoComplete="off"
        onFinish={submit}
        layout="vertical"
        scrollToFirstError>
        <Form.Item
          label="市场归属"
          name="name"
          rules={[{ required: true, message: '请输入市场归属' }]}>
          <Input placeholder="请输入市场归属" allowClear />
        </Form.Item>
        <Form.Item
          name="head"
          label="负责人"
          rules={[{ required: true, message: '请输入负责人' }]}
        >
          <Input placeholder="请输入负责人" />
        </Form.Item>
        <Form.Item
          name="tel"
          label="联系方式"
          rules={[{ required: true, message: '请输入联系方式' }]}
        >
          <Input placeholder="请输入联系方式" />
        </Form.Item>
        <Form.Item
          label="评级"
          name="grade"
          rules={[{ required: true, message: '请选择评级' }]}
        >
          <Select
            placeholder="请选择评级"
            options={safeGrade}
            allowClear
            showArrow
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item
          label="合作状态"
          name="state"
          rules={[{ required: true, message: '请选择合作状态' }]}
        >
          <Select
            placeholder="请选择合作状态"
            options={safeState}
            allowClear
            showArrow
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item
          name="remark"
          label="备注"
          rules={[{ required: true, message: '请输入备注' }]}
        >
          <Input.TextArea showCount placeholder="请输入备注" style={{ height: 120 }} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default OperateModal;
